<template>
    <HeaderContent title="Activity" />
    <ActionContent
        ctaText="Activity"
        :filterDate="false"
        :filterModal="false"
        @action="createModal"
        @search-query="searchData"
    />
    <ActivityForm
        :modal="modal"
        :selectedData="selectedData"
        @update:modal="updateModal"
        @addOrUpdate="getAll"
    ></ActivityForm>

    <DataTable
        :data="activityList"
        :header="headers"
        :custom-actions="customActions"
    >
    </DataTable>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import DataTable from "@/components/DataTable.vue";
import { ref, onMounted, inject } from "vue";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import { formatRupiah } from "@/utils/format";
import ActivityForm from "./ActivityForm.vue";

const auth = useAuthStore();
const $loading = useLoading();
const selectedData = ref({});
const modal = ref(false);
const swal = inject("$swal");
const toast = useToast();

const headers = ref([
    {
        key: "no",
        label: "No",
        thClass: "text-center px-1",
        tdClass: "text-center px-1",
    },
    {
        key: "destination_format",
        label: "Destination",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "name",
        label: "Activity Name",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "description",
        label: "Description",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left text-wrap",
        formatter: (value) => {
            if (!value) return "-";
            return value.length > 100 ? value.substring(0, 100) + "..." : value;
        },
    },
    { key: "pax", label: "Pax", sortable: true },
    {
        key: "price_format",
        label: "Price",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
    },
    {
        key: "sub_total_format",
        label: "Subtotal",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
    },
    { key: "action", label: "Action" },
]);
const customActions = ref([
    {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
            selectedData.value = item;
            modal.value = true;
            // getByUuid(item.uuid);
        },
    },
    {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
            swal({
                title: "Confirm",
                text: "Are you sure to delete this data?",
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                cancelButtonText: "Cancel",
                customClass: {
                    popup: "rounded",
                    confirmButton: "btn btn-danger me-2",
                    cancelButton: "btn btn-secondary",
                },
                buttonsStyling: false,
            }).then((confirm) => {
                if (confirm.value) {
                    deleteData(item.uuid);
                } else {
                    swal.close();
                }
            });
        },
    },
]);

const searchData = async (search) => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll(search);
    } finally {
        loader.hide();
    }
};

const createModal = () => {
    selectedData.value = {};
    modal.value = true;
};

const updateModal = (newValue) => {
    modal.value = newValue;
};

let activityList = ref([]);

const getAll = async (search = "") => {
    const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/activity`,
        {
            params: {
                search: search,
            },
            headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + auth._token,
            },
        }
    );

    const res = response.data;

    if (res.status) {
        activityList.value = res.data.map((i) => ({
            ...i,
            destination_format: i.destination
                ? `${i.destination.name} (${i.destination.code})`
                : "-",
            description: i.description ?? "-",
            price_format: formatRupiah(i.price),
            sub_total_format: formatRupiah(i.sub_total),
        }));
    }
};

// const getByUuid = async (uuid) => {
//     if (uuid) {
//         toast.clear();
//         const loader = $loading.show({
//             color: "#009689",
//             loader: "bars",
//             zIndex: 999999,
//         });

//         try {
//             const response = await axios.get(
//                 `${process.env.VUE_APP_API_URL}/route/detail/${uuid}`,
//                 {
//                     headers: {
//                         "Content-type": "application/json",
//                         Authorization: "Bearer " + auth._token,
//                     },
//                 }
//             );

//             const res = response.data;

//             if (res.status) {
//                 selectedData.value = res.data;
//                 modal.value = true;
//             }
//         } finally {
//             loader.hide();
//         }
//     }
// };

const deleteData = async (uuid) => {
    console.log(uuid);
    if (uuid) {
        toast.clear();
        const loader = $loading.show({
            color: "#009689",
            loader: "bars",
            zIndex: 999999,
        });

        try {
            const response = await axios.delete(
                `${process.env.VUE_APP_API_URL}/activity/delete/${uuid}`,
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                getAll();
            }
        } finally {
            loader.hide();
        }
    }
};

onMounted(async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll();
    } finally {
        loader.hide();
    }
});
</script>
